// Separate file so when we mapStateToProps we can use shorthand object notation
import { queryState, createState, updateState } from "./creator";

export const queriedTargets = queryState.selector;

export const createTargetObj = createState.selector;

export const updateTargetObj = updateState.selector;
